import { bool } from 'prop-types'
import * as React from 'react'
import { InputIconSearch, InputIconSearchPath } from './IconSearch.style'

const propTypes = {
  disabled: bool,
}

const IconSearch = ({ disabled = false }) => (
  <InputIconSearch
    aria-hidden="true"
    role="img"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <InputIconSearchPath
      disabled={disabled}
      d="M11.059 18.118a7.059 7.059 0 100-14.118 7.059 7.059 0 000 14.118zM20 20l-3.95-3.95"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </InputIconSearch>
)

IconSearch.propTypes = propTypes

export { IconSearch }
